import PropTypes from "prop-types"
import React from "react"
import { dispatch } from "../../Dispatcher"
import Badge from "../elements/Badge"
import SearchFilters from "../modules/SearchFilters"
import SearchDisplayTools from "../modules/SearchDisplayTools"
import { injectIntl, FormattedMessage, FormattedHTMLMessage } from "react-intl"
import searchMessages from "../../messages/search"
import { isToko } from "../../scripts/maori"
import { SEARCH_ARTICLE_STYLES } from "../../constants"
import { getStyles, getStyleTag } from "../../styles/dynamicStyles"
import { decodeBreadcrumbsParameters } from "../../routes"

class SearchControls extends React.Component {
  state = {
    articleStyles: SEARCH_ARTICLE_STYLES
  }

  getBreadcrumbsLabels = () => {
    const { breadcrumbsSearch } = this.props

    if (!breadcrumbsSearch) {
      return []
    }

    const breadcrumbsLabels = []
    const breadcrumbs = Object.entries(breadcrumbsSearch).map(
      ([key, value]) => ({
        key,
        value
      })
    )
    breadcrumbs.forEach(breadcrumb => {
      const { key, value } = breadcrumb

      if (!value) {
        return
      }

      const selectedBreadcrumbs = decodeBreadcrumbsParameters(value)
      const breadcrumbsArr = Object.values(selectedBreadcrumbs).reverse()[0]
      const breadcrumbsLabel = breadcrumbsArr
        .map(item => item.title)
        .join(" > ")

      breadcrumbsLabels.push({ key, value: breadcrumbsLabel })
    })

    return breadcrumbsLabels
  }

  render() {
    const {
      q,
      showSearchFilters,
      hideDisplayTools,
      articleStyle,
      types,
      licenses,
      terms,
      tags,
      filterConfiguration,
      filterControls,
      filters,
      dates,
      facets,
      total,
      intl,
      breadcrumbsSearch
    } = this.props

    const { articleStyles } = this.state

    const toko = isToko(total)
    const breadcrumbsLabels = this.getBreadcrumbsLabels()

    return (
      <div
        className="search-results__tools"
        style={getStyles("search-results__tools")}
      >
        <div
          className="column row"
          style={getStyles("search-results__tools__row")}
        >
          <div className="search-results__tools-inner">
            <div
              className="c-results-panel search-results__panel"
              style={getStyles(["search-results__panel-search-tool"])}
            >
              {hideDisplayTools ? null : (
                <SearchDisplayTools
                  articleStyles={articleStyles}
                  articleStyle={articleStyle}
                />
              )}
              {getStyleTag("c-results-panel__title")}
              <h3
                className="c-results-panel__title"
                style={getStyles("c-results-panel__title")}
              >
                {toko && (
                  <FormattedHTMLMessage
                    {...searchMessages.foundTotal}
                    values={{ total: total }}
                  />
                )}
                {!toko && (
                  <FormattedHTMLMessage
                    {...searchMessages.foundTotalE}
                    values={{ total: total }}
                  />
                )}
                {(q.length > 0 || terms.length > 0) && (
                  <span>
                    {" "}
                    <FormattedMessage {...searchMessages.for} />
                  </span>
                )}
                <span className="c-results-panel__badges">
                  {q && (
                    <Badge
                      key={q}
                      onClick={() =>
                        dispatch({ type: "clear-search-term", q: "" })
                      }
                      isClosable={true}
                      closeBtnTitle={intl.formatMessage(
                        searchMessages.removeQueryTerm
                      )}
                    >
                      {q}
                    </Badge>
                  )}
                  {terms.map(term => (
                    <Badge
                      key={term}
                      onClick={() =>
                        dispatch({ type: "remove-query-term", term: term })
                      }
                      isClosable={true}
                      closeBtnTitle={intl.formatMessage(
                        searchMessages.removeQueryTerm
                      )}
                    >
                      {term}
                    </Badge>
                  ))}
                  {breadcrumbsLabels.map(({ key, value }) => (
                    <Badge
                      key={key}
                      onClick={() =>
                        dispatch({
                          type: "clear-breadcrumbs-term",
                          name: key
                        })
                      }
                      isClosable={true}
                      closeBtnTitle={intl.formatMessage(
                        searchMessages.removeQueryTerm
                      )}
                    >
                      {value}
                    </Badge>
                  ))}
                </span>
              </h3>
            </div>
            <SearchFilters
              total={total}
              expanded={showSearchFilters}
              activeTypes={types}
              activeLicenses={licenses}
              activeTags={tags}
              facets={facets}
              filterConfiguration={filterConfiguration}
              filterControls={filterControls}
              activeFilters={filters}
              dates={dates}
              articleStyle={articleStyle}
              articleStyles={articleStyles}
              breadcrumbsSearch={breadcrumbsSearch}
            />
          </div>
        </div>
      </div>
    )
  }
}

SearchControls.propTypes = {
  articleStyle: PropTypes.string.isRequired,
  showSearchFilters: PropTypes.bool.isRequired,
  q: PropTypes.string,
  types: PropTypes.array,
  licenses: PropTypes.array,
  terms: PropTypes.array,
  tags: PropTypes.array,
  filterControls: PropTypes.array,
  filters: PropTypes.object,
  dates: PropTypes.object,
  facets: PropTypes.object,
  total: PropTypes.number.isRequired,
  breadcrumbsSearch: PropTypes.object
}

export default injectIntl(SearchControls)



// WEBPACK FOOTER //
// ./webapp/components/modules/SearchControls.js